var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: " " }, [
    _vm.search_add_user == false
      ? _c(
          "div",
          [
            _c(
              "div",
              {
                staticClass:
                  " d-flex justify-content-between align-items-center "
              },
              [
                _c("h2", { staticClass: "h2-responsive" }, [
                  _c(
                    "span",
                    {
                      staticClass: "btn-primary btn-floating mr-2",
                      on: {
                        click: function($event) {
                          _vm.search_add_user = true
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.role_description) + " Users")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("table-search", {
              attrs: {
                laravel_route_uri: _vm.table_laravel_route_uri,
                request_route_url: _vm.table_request_route_url,
                crud: _vm.table_crud,
                reload: _vm.table_reload,
                emit_table_event_key_prop: "emit_table_event"
              },
              on: { emit_table_event: _vm.tableActionEventHandler }
            })
          ],
          1
        )
      : _c("div", [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass:
                    " d-flex justify-content-start d-flex align-items-center "
                },
                [
                  _vm.selected_users.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "btn btn-primary",
                          on: {
                            click: function($event) {
                              _vm.addUsersSubmit()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Save\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selected_users.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "btn btn-primary",
                          on: {
                            click: function($event) {
                              _vm.init()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        cancel\n                    "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]),
            _vm._v(" "),
            _vm.selected_users.length <= 0
              ? _c(
                  "div",
                  { staticClass: "col-12 col-md-8" },
                  [
                    _c("search-bar", {
                      attrs: {
                        close_search_action: "close_search_action",
                        open_on_load: "true"
                      },
                      on: {
                        search_event: _vm.searchEvent,
                        close_search_event: function($event) {
                          _vm.closeSearch()
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-responsive" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                !_vm.isEmpty(_vm.users)
                  ? _c(
                      "table",
                      {
                        staticClass:
                          "table w-auto table-striped table-hover table-bordered"
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("First")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Last")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Email")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Roles")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.users, function(user) {
                            return _c(
                              "tr",
                              {
                                class: {
                                  "table-primary": _vm.userInSelected(user),
                                  "cursor-pointer": _vm.userInSelected(user),
                                  "cursor-copy": !_vm.userInSelected(user)
                                },
                                on: {
                                  click: function($event) {
                                    _vm.toggleUserToListSubmissionList(user)
                                  }
                                }
                              },
                              [
                                _c("td", [_vm._v(_vm._s(user.first_name))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(user.last_name))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(user.email))]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  _vm._l(user.roles, function(role) {
                                    return _c(
                                      "span",
                                      {
                                        class: {
                                          "badge badge-primary":
                                            parseInt(role.id) ===
                                            parseInt(_vm.role_id)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                           " +
                                            _vm._s(role.name) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  })
                                )
                              ]
                            )
                          })
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62907bc7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62907bc7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/forms/search/SearchUserRoleCrud.vue
// module id = 723
// module chunks = 0